const viewPTUrl = (ptId, operatorId) => {
  return `/operators/${operatorId}/pts/${ptId}`
}

export default viewPTUrl
